import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Languages } from "lucide-react";

interface LanguageSwitcherProps {
    readonly className?: string;
    readonly align?: "start" | "center" | "end";
}

export function LanguageSwitcher({ className, align = "end" }: LanguageSwitcherProps) {
    const { i18n } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    const currentLanguage = i18n.language;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" aria-label="Change Language" className={className}>
                    <Languages className="h-5 w-5" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align={align}>
                <DropdownMenuItem
                    onClick={() => changeLanguage("en")}
                    className={currentLanguage.startsWith("en") ? "bg-accent" : ""}
                >
                    <span className="mr-2 text-lg"></span> English
                </DropdownMenuItem>
                <DropdownMenuItem
                    onClick={() => changeLanguage("de")}
                    className={currentLanguage.startsWith("de") ? "bg-accent" : ""}
                >
                    <span className="mr-2 text-lg"></span> Deutsch
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
